package org.molap.dataframe

import org.molap.index.EmptyUniqueIndex
import org.molap.index.UniqueIndex
import kotlin.reflect.KClass

class EmptyDataFrame private constructor() : AbstractDataFrame<Any?,Any?,Any?>() {
    override fun getRowClass(o: Any?): KClass<*>? {
        return null
    }

    override fun getColumnClass(o: Any?): KClass<*> {
        return Any::class
    }

    override fun getValueAt(o: Any?, o2: Any?): Any? {
        return null
    }

//    override fun getRow(o: Any?): Series<Any?,Any?>? {
//        return null
//    }

    override val rowIndex: UniqueIndex<Any?>
        get() = EmptyUniqueIndex.instance

    override val columnIndex: UniqueIndex<Any?>
        get() = EmptyUniqueIndex.instance

    companion object {
        val instance: EmptyDataFrame = EmptyDataFrame()
    }
}
